/**
 * Kaksos Portal - Unbonded Page
 *
 * Rendered by ProtectedRoute when an authenticated peeler's bond_status is
 * not 'bonded'. Refuses entry and routes them back to the peeler portal,
 * where the Drawbridge UI handles age verification and bond activation.
 *
 * Wisdom §4 — fail loudly, not silently.
 * Wisdom §18 — bond activation UI lives in peeler-portal only.
 */

import { useNavigate } from 'react-router-dom';
import { authApi, AUTH_API_URL } from '../lib/api';

export default function UnbondedPage() {
    const navigate = useNavigate();

    const handleSignOut = () => {
        authApi.logout();
        navigate('/login');
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-50 via-gray-50 to-amber-50 flex items-center justify-center p-4">
            <div className="w-full max-w-md">
                {/* Logo */}
                <div className="text-center mb-8">
                    <img
                        src="/Bobylogo.png"
                        alt="BOBY"
                        className="h-16 mx-auto mb-4"
                        onError={(e) => {
                            (e.target as HTMLImageElement).style.display = 'none';
                        }}
                    />
                    <h1 className="text-xl font-semibold text-gray-800">Kaksos Portal</h1>
                </div>

                {/* Honest gate */}
                <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
                    <h2 className="text-lg font-semibold text-gray-800 mb-3">
                        Your bond is not yet activated
                    </h2>
                    <p className="text-gray-600 leading-relaxed mb-6">
                        Your Kaksos is waiting. Complete age verification and bond activation in your peeler portal first.
                    </p>

                    <a
                        href={AUTH_API_URL}
                        className="block w-full bg-amber-400 hover:bg-amber-500 text-gray-900 font-semibold text-center py-3 rounded-xl transition-colors shadow-sm hover:shadow-md"
                    >
                        Go to Peeler Portal →
                    </a>

                    <div className="mt-6 pt-4 border-t border-gray-100 text-center">
                        <button
                            onClick={handleSignOut}
                            className="text-sm text-gray-500 hover:text-gray-700"
                        >
                            Sign out
                        </button>
                    </div>
                </div>

                {/* Footer */}
                <p className="text-center text-xs text-gray-400 mt-8">
                    © {new Date().getFullYear()} BOBY Security Intelligence Service
                </p>
            </div>
        </div>
    );
}
